// import $ from 'jquery';
import PreferabliSTPApp from './stp.class';

'use strict';
(function ($) {

  if (!window.jQuery) {
    throw new Error("jQuery is required for PreferabliSTP plugin.");
  }

  function PreferabliSTP(element, options) {

    this._defaultOptions = {
      gallery: {
        type: 'carousel',
        productsToDisplay: 4,
      },
      display: {
        separator: null,
        layout: 'row',
        use_preferabli_logo: false,
        logo_placement: 'top-right',
        logo_option: 9,
        logo_inline_style: {},
        logo_class: '',
      },
      hideHeading: false,
      helpTooltip: false,
      devMode: false,
      openNewTab: false,
      showDecimalPlaces: true,
      numDecimalPlaces: 2,
      showLink: true,
      customText: null,
      renderProductCards: null,
      onRenderComplete: null,
      productCardsContainer: null,
      lang: 'en',
      opt_out_tracking: false,
      allowedLanguage: null,
      defaultLanguage: null
    };


    if (!element || !(element instanceof Element || (element instanceof jQuery && element[0] instanceof Element) || typeof element === 'string')) {
      throw 'A valid DOM element or selector is required to initialize Preferabli Similar Tasting Products plugin.';
    }

    if (!options || typeof options.integration_id === 'undefined') {
      throw 'integration_id is required for PreferabliSTP.';
    }

    const el = element instanceof jQuery ? element[0] : 
               (typeof element === 'string' ? document.querySelector(element) : element);

    this.element = el;

    this.opts = $.extend({}, this._defaultOptions, Object.assign( options, {
      root: el,
    }));

    const browserLang = String(navigator.language || navigator.userLanguage || '').split('-')[0];
    if (Array.isArray(options?.allowedLanguage) && options.allowedLanguage.length) {
      if (options.allowedLanguage.includes(browserLang)) {
        // run on the browserLang. if in the allowedLang
        this.opts.lang = browserLang;
      } else if (options.defaultLanguage) {
        // run on the defaultlang
        this.opts.lang = options.defaultLanguage;
      } else {
        // run on the defaults lang
        if(!this.opts.lang && !options.lang) this.opts.lang = this._defaultOptions.lang;
        if(!this.opts.lang && options.lang) this.opts.lang = options.lang;
      }
    } else if (options?.defaultLanguage) {
      // run on the defaultlang
      this.opts.lang = options.defaultLanguage;
    } else {
      // run on the defaults lang
      if(!this.opts.lang && !options.lang) this.opts.lang = this._defaultOptions.lang;
      if(!this.opts.lang && options.lang) this.opts.lang = options.lang;
    }

    this._name = 'preferabliSTP';
    this._stp = null;

    this.init();
  }

  PreferabliSTP.prototype = {
      constructor: PreferabliSTP,
      init: function () {
        this._stp = new PreferabliSTPApp(this.element, {
          ...this.opts,
          element: this.element,
        });

        // Legacy aliases on global for direct access
        window.preferabliSTP = this._stp;
        window.WRLikeThatTryThis = this._stp;
        window.PreferabliLTTT = this._stp;
      },

      getProducts: function (params) {
        this._stp.getLTTT(params);
      }
  };

  $.fn.preferabliSTP = function (options) {
    const isCommand = typeof options === 'string';
    const args = Array.prototype.slice.call(arguments, 1);

    return this.each(function () {
      const $el = $(this);
      let instance = $el.data('preferabliSTP');

      if (isCommand) {
        if (instance && typeof instance[options] === 'function') {
          instance[options](...args);
        }
      } else {
        if (!instance) {
          const opts = $.extend(true, {}, options);
          instance = new PreferabliSTP(this, opts);
          $el.data('preferabliSTP', instance);
        }
      }
    });
  };

  // Aliases
  $.fn.preferabliSimilarTastingProducts = $.fn.preferabliSTP;
  $.fn.preferabliLTTT = $.fn.preferabliSTP;
  $.fn.wrLikeThatTryThis = $.fn.preferabliSTP;

})(window.jQuery);
